<template>
  <div class="api-page">
    <el-button @click="login()">测试登录</el-button>
    <pre>{{ loginRes }}</pre>
    <!--{{timezones}}-->
    <!--<hi-dialog></hi-dialog>-->
    <div style="padding: 40px">
      <hi-tabs>
        <hi-tab-panel :title="'标题1'">
          <div>111</div>
        </hi-tab-panel>
        <hi-tab-panel :title="'标题2'">
          <div>222</div>
        </hi-tab-panel>
        <hi-tab-panel :title="'标题3'">
          <div>333</div>
        </hi-tab-panel>
      </hi-tabs>
    </div>
  </div>
</template>

<script>
import { login } from "../../service/publisher";
import { timezones } from "../../const/timezone";
import hiTabs from "../../components/common/tab/Index.vue";
import hiTabPanel from "../../components/common/tab/Panel.vue";
export default {
  name: "ApiPage",
  components: { hiTabs, hiTabPanel },
  data() {
    return {
      loginRes: null,
      timezones,
    };
  },
  methods: {
    async login() {
      this.loginRes = await login({ username: "akrionsmail" });
    },
  },
};
</script>

<style lang="less" scoped>
.api-page {
}
</style>
